


















// Vue
import { computed, defineComponent, PropType } from '@vue/composition-api'

// Model
import { ReasonForTerminationWorkForm } from '@/models/config'

// Components
import { FormCreateEditReasonForTerminationWork } from '@/components/config'

export default defineComponent({
    name: 'ModalCreateEditReasonForTerminationWork',
    components: {
        FormCreateEditReasonForTerminationWork
    },
    props: {
        show: {
            type: Boolean as PropType<boolean>,
            default: false
        },
        actionForm: {
            type: String as PropType<string>,
            default: 'save'
        },
        idEdit: {
            type: Number as PropType<number|null>,
            default: null
        },
        reason: {
            type: Object as PropType<ReasonForTerminationWorkForm>,
            required: true
        }
    },
    setup (props) {
        const title = computed(() => {
            if (props.actionForm === 'save') {
                return 'Crear Nuevo Motivo de Permiso'
            }
            return 'Editar Motivo de Permiso'
        })
        return {
            title
        }
    }
})
